module.exports = __webpack_public_path__ + "static/media/id_card_bg.09f766a9.png";